module.exports = __webpack_public_path__ + "media/images/equipments-img-01-d91162e6b0c603be4e1d4b842958eb1f.jpg";